
import { useState, useEffect, useContext } from "react";
import { get_tiptap_test_data, get_tiptap_doc } from '../../../services/projectservice.js';
import TipTapEditor from "./tiptap/TipTapEditor";
import { AuthContext } from '../../../AuthContext.jsx';
import { ConfigContext } from '../../../ConfigContext.jsx';


export default function ArtistStatementEditor() {

    const { authToken, claims, isLoading, onLogout } = useContext(AuthContext);
    const { bootstrapConfig } = useContext(ConfigContext);

    const [ editorContent, setEditorContent ] = useState('');
    const [ loadError, setLoadError ] =  useState(''); 

    const handleLoad = (data) => {
        setEditorContent(data.data); 
    }

    const handleLoadError = (error) => {
        console.error("Error loading data:", error);
        setLoadError(`Error loading data: ${error}`);
    }

    useEffect(() => { 
        if (bootstrapConfig && Object.keys(bootstrapConfig).length) {
            get_tiptap_doc(bootstrapConfig.artiststatement_doc_id, authToken, handleLoad, handleLoadError)
        }

    }, [bootstrapConfig]);
    
    return (
        <div>
            <h1>Artist Statement Editor</h1> 
            { editorContent && <TipTapEditor initialContent={editorContent} doc_id={bootstrapConfig.artiststatement_doc_id} /> }
            { loadError && <div style={{ color: 'red' }}>{loadError}</div>  }
        </div>
    );
}
